import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import format from 'date-fns/format';
import Typography from '@material-ui/core/Typography';
import { getConfigs } from '../../app/selectors';

const SchedulePublicationContent = ({ data }) => {
  const { dateFormat } = useSelector(getConfigs).toJS();
  const { targetPublishDate } = data;
  const targetPublishDateFormatted = format(
    new Date(targetPublishDate),
    dateFormat
  );
  return (
    <>
      <FormattedMessage
        id="ppsi.approvalScheduledPublicationText"
        values={{
          br: <br />,
          targetPublishDate: targetPublishDateFormatted
        }}
      />
      <p style={{ marginBottom: 0 }}>
        <Typography variant="caption">
          <FormattedMessage id="ppsi.approvalScheduledPublicationNote" />
        </Typography>
      </p>
    </>
  );
};

export default SchedulePublicationContent;
